import React from 'react';
import { motion } from 'framer-motion';
import { X, Sparkles, ThumbsUp, Eye, Tag } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export default function AIContentDetail({ content, onClose, onMarkHelpful }) {
  const contentTypeLabels = {
    tip: 'Consejo',
    article: 'Artículo',
    fact: 'Dato Interesante',
    recipe_suggestion: 'Receta Sugerida'
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className="w-full max-w-2xl bg-white rounded-2xl shadow-xl max-h-[90vh] overflow-y-auto"
      >
        <div className="sticky top-0 bg-gradient-to-br from-indigo-500 to-purple-600 p-6 flex items-center justify-between text-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
              <Sparkles className="w-5 h-5" />
            </div>
            <div>
              <p className="text-sm opacity-90">Contenido generado por IA</p>
              <h2 className="text-xl font-bold">{contentTypeLabels[content.content_type]}</h2>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          {content.image_url && (
            <img 
              src={content.image_url} 
              alt={content.title}
              className="w-full h-48 object-cover rounded-xl mb-6"
            />
          )}

          <h1 className="text-2xl font-bold text-gray-900 mb-4">{content.title}</h1>
          
          <div className="prose prose-sm max-w-none mb-6">
            <p className="text-gray-700 whitespace-pre-line">{content.content}</p>
          </div>

          {content.tags && content.tags.length > 0 && (
            <Card className="p-4 bg-gray-50 mb-6">
              <div className="flex items-center gap-2 mb-2">
                <Tag className="w-4 h-4 text-gray-600" />
                <span className="text-sm font-medium text-gray-700">Etiquetas:</span>
              </div>
              <div className="flex flex-wrap gap-2">
                {content.tags.map((tag, index) => (
                  <span 
                    key={index} 
                    className="px-3 py-1 bg-white text-indigo-700 text-sm rounded-full border border-indigo-200"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </Card>
          )}

          <div className="flex items-center justify-between pt-4 border-t border-gray-100">
            <div className="flex items-center gap-4 text-sm text-gray-500">
              <div className="flex items-center gap-1">
                <Eye className="w-4 h-4" />
                <span>{content.view_count || 0} vistas</span>
              </div>
              <div className="flex items-center gap-1">
                <ThumbsUp className="w-4 h-4" />
                <span>{content.helpful_count || 0} útiles</span>
              </div>
            </div>
            
            <Button 
              onClick={onMarkHelpful}
              className="bg-indigo-600 hover:bg-indigo-700"
            >
              <ThumbsUp className="w-4 h-4 mr-2" />
              Marcar como útil
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}